import type { ErrorInfo } from "react";

import styles from "../../ErrorBoundary.module.css";

interface ErrorDisplayProps {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export const ErrorDisplay = ({ error, errorInfo }: ErrorDisplayProps) => {
  return (
    <>
      <div className={styles.header}>
        <span className={styles.errorIndicator}>
          <span className={styles.errorDot} aria-hidden="true" />
          Application Error
        </span>
        <h1 className={styles.errorTitle}>Something went wrong</h1>
        <p className={styles.errorDescription}>
          The app encountered an unexpected error and needs to restart.
        </p>
      </div>

      {error && (
        <details className={styles.errorDetails}>
          <summary className={styles.errorDetailsSummary}>
            Technical details
          </summary>
          <div className={styles.errorDetailsContent}>
            <p className={styles.errorMessage}>{error.toString()}</p>
            {errorInfo && (
              <pre className={styles.errorStack}>
                {errorInfo.componentStack}
              </pre>
            )}
          </div>
        </details>
      )}
    </>
  );
};
